var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftBackground32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.381282 6.38128C0.0395728 6.72299 0.0395728 7.27701 0.381282 7.61872L5.94975 13.1872C6.29146 13.5289 6.84548 13.5289 7.18718 13.1872C7.52889 12.8455 7.52889 12.2915 7.18718 11.9497L2.23744 7L7.18718 2.05025C7.52889 1.70854 7.52889 1.15452 7.18718 0.812816C6.84548 0.471107 6.29146 0.471107 5.94975 0.812816L0.381282 6.38128ZM1 7.875H17V6.125H1V7.875Z",
    fill: "#21244B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftBackground32);
export default __webpack_public_path__ + "static/media/arrow-left-background3_2.f696199562181c61acb187bfa83ab934.svg";
export { ForwardRef as ReactComponent };